import { LifeApi } from '@/modules/life/core/api'
import { UserApi } from '@/modules/user/core/api'
import { WxApi } from '@/modules/user/core/wxApi'

export class BTApi {
    wx = new WxApi();
    life = new LifeApi();
    user = new UserApi();
}